<div class="login-image">
  <div class="gradient-overlay"></div>
  <div class="bubbles">
    @for (bubble of bubbleImages(); track bubble.bubbleIndex) {
      <span
        [class.bubble-active]="true"
        [class.has-image]="bubble.url"
        [class.image-visible]="bubble.visible && !bubble.fading"
        [class.image-fading]="bubble.fading"
      >
        @if (bubble.url) {
          <img [src]="bubble.url" alt="Brand preview" />
        }
      </span>
    }
  </div>

  <div class="image-content">
    <div class="brand-logo">
      <a routerLink="/">
        <img
          src="https://insizon-email-templates-bucket.s3.us-east-2.amazonaws.com/insizon/insizon-logo-v2-png.png"
          alt="Insizon Logo"
          class="logo-image" />
      </a>
    </div>
    <h3 class="welcome-text">{{ welcomeText() }}</h3>
    <div class="welcome-subtitle">
      {{ welcomeSubtitle() }}
    </div>
  </div>
</div>
